module.exports = __webpack_public_path__ + "img/delivery.78c4bad5.svg";